import { SelectInput } from '../baseInputs'

type Props = {
  dealers?: []
  helper?: string
  optional?: boolean
  label?: string
}

const ClosestDealers = ({
  helper,
  dealers,
  label,
  optional,
  ...rest
}: Props) => {
  const name = 'dealer'

  return (
    <SelectInput
      name={name}
      label={label}
      options={dealers}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default ClosestDealers
